module.exports=function(url){var a=document.createElement("a");return a.href=url,a};